$(function () {
    const $form = $('[data-stock-action-form]');
    if (!$form.length) {
        return;
    }

    const endpoint = $form.data('balancesUrl');
    const fifoEndpoint = $form.data('fifoUrl');
    const previewEndpoint = $form.data('previewUrl');
    const saleExpensePreviewEndpoint = $form.data('saleExpensePreviewUrl');
    const exitPreviewEndpoint = $form.data('exitPreviewUrl');
    const operation = $form.data('operation');
    const $source = $form.find('[name="' + ($form.data('sourceField') || 'source_property_id') + '"]');
    const $targetProperty = $form.find('[name="target_property_id"]');
    const $balance = $form.find('[data-stock-balance]');
    const $quantity = $form.find('[name="quantity"]');
    const $availability = $form.find('[data-stock-availability]');
    const $units = $form.find('[data-stock-units]');
    const $unitsGroup = $form.find('[data-stock-units-group]');
    const $detailedUnits = $form.find('[data-unit-list]');
    const $newStatus = $form.find('[name="new_status"]');
    const $fifoPreview = $form.find('[data-stock-fifo-preview]');
    const $fifoPreviewText = $form.find('[data-stock-fifo-preview-text]');
    const $saleExpensePreview = $form.find('[data-sale-expense-preview]');
    const $saleLotFields = $form.find('[data-sale-lot-fields]');
    const $saleLot = $form.find('[data-sale-lot]');
    const $saleGroup = $form.find('[data-sale-group]');
    const $saleGroupField = $form.find('[data-sale-group-field]');
    const $saleGroupAvailability = $form.find('[data-sale-group-availability]');
    const $saleGroupSummary = $form.find('[data-sale-group-summary]');
    const $saleCostFields = $form.find('[data-sale-cost-fields]');
    const $saleUnknownFields = $form.find('[data-sale-unknown-fields]');
    const $saleSelection = $form.find('[data-sale-selection]');
    const $saleSubmit = $saleSelection.length ? $form.find('button:submit').first() : $();
    const prefillBalanceId = Number($form.data('prefillBalanceId')) || null;
    const prefillRecognitionGroup = $form.data('prefillRecognitionGroup') || null;
    const $moveGroup = $form.find('[data-move-group]');
    const $moveGroupField = $form.find('[data-move-group-field]');
    const $recognitionLot = $form.find('[data-recognition-lot]');
    const $recognitionLotField = $form.find('[data-recognition-lot-field]');
    const $recognitionSubmit = $form.find('[data-submit-btn]');
    let saleLots = [];
    let salePreviewRequest = 0;
    let exitPreviewRequest = 0;
    let commissioningPreviewRequest = 0;
    const $exitGroup = $form.find('[data-exit-group]');
    const $exitGroupFields = $form.find('[data-exit-group-fields]');
    const $exitSelection = $form.find('[data-exit-selection]');
    const $exitPreview = $form.find('[data-exit-preview]');
    const $exitSubmit = exitPreviewEndpoint ? $form.find('button[type="submit"], button:not([type])').first() : $();

    function showExitEffects(expense, unknown) {
        $form.find('[data-exit-cost-fields]').toggle(expense).find(':input').prop('disabled', !expense);
        $form.find('[data-exit-cost-fields] .selectpicker').selectpicker('refresh');
        $form.find('[data-exit-unknown-fields]').toggle(unknown).find(':checkbox').prop('disabled', !unknown).prop('required', unknown);
        if (!unknown) $form.find('[data-exit-unknown-fields] :checkbox').prop('checked', false);
    }

    function loadExitPreview() {
        if (!exitPreviewEndpoint) return;
        const request = ++exitPreviewRequest;
        $exitSelection.val('').prop('disabled', true);
        $exitSubmit.prop('disabled', true);
        showExitEffects(false, false);
        const itemId = $form.find('[name="stock_item_id"]').val();
        const dateValue = $form.find('[name="consumption_date"], [name="write_off_date"]').first().val();
        const exitDate = /^\d{2}\.\d{2}\.\d{4}$/.test(dateValue) ? dateValue.split('.').reverse().join('-') : dateValue;
        const unitIds = $form.find('input[name="unit_ids[]"]').map(function () { return $(this).val(); }).get().concat($unitsGroup.is(':visible') ? ($units.val() || []) : []);
        const quantity = unitIds.length || Number($quantity.val());
        const quantityTracked = $balance.find(':selected').data('tracking-mode') === 'quantity';
        if (hasMixedUnitGroups()) {
            $exitPreview.text('Выбранные экземпляры относятся к разным группам учёта стоимости. Проведите каждую группу отдельно.');
            return;
        }
        if (quantityTracked && !$exitGroup.val()) {
            $exitPreview.text($exitGroup.find('option').length > 1 ? 'Выберите доступную группу учёта стоимости ТМЦ.' : 'Нет подтверждённой истории групп; перед списанием нужна сверка.');
            return;
        }
        if (quantityTracked && $quantity.attr('max') && Number($quantity.val()) > Number($quantity.attr('max'))) {
            $exitPreview.text('Количество превышает доступный остаток выбранной группы.');
            return;
        }
        if (!$source.val() || !itemId || !quantity || !exitDate || ($unitsGroup.is(':visible') && !unitIds.length)
            || ($balance.find(':selected').data('tracking-mode') === 'individual' && !unitIds.length)) {
            $exitPreview.text('Выберите ТМЦ, дату, группу и количество для расчёта стоимости.');
            return;
        }
        $exitPreview.text('Рассчитываем стоимость выбранных ТМЦ…');
        $.getJSON(exitPreviewEndpoint, {
            operation: operation, source_property_id: $source.val(), stock_item_id: itemId,
            source_status: $form.find('[name="source_status"]').val(), quantity: quantity, exit_date: exitDate,
            recognition_group: $exitGroup.val() || undefined, unit_ids: unitIds,
            stock_lot_id: $form.find('input[name="stock_lot_id"]').val() || undefined,
        }).done(function (response) {
            if (request !== exitPreviewRequest) return;
            const data = response.data;
            showExitEffects(data.expense_kopecks > 0, data.unknown_cost);
            $exitSelection.val(data.selection).prop('disabled', false);
            $exitSubmit.prop('disabled', false);
            const lots = data.lots.map(function (entry) {
                return (entry.unit_id ? 'Экземпляр #' + entry.unit_id : 'Партия #' + entry.lot_id) + ': ' + entry.quantity + ' шт., ' + (entry.cost_share_kopecks === null ? 'стоимость неизвестна' : (entry.cost_share_kopecks / 100).toFixed(2) + ' ₽');
            }).join('; ');
            $exitPreview.text(lots + (data.unknown_cost ? '. Для выбранной неизвестной стоимости расход не создаётся.' : '. Управленческий расход: ' + (data.expense_kopecks / 100).toFixed(2) + ' ₽.'));
        }).fail(function (xhr) {
            if (request !== exitPreviewRequest) return;
            $exitPreview.text((xhr.responseJSON && xhr.responseJSON.message) || 'Не удалось рассчитать стоимость выбранных ТМЦ.');
        });
    }

    function showSaleCostFields(show) {
        $saleCostFields.toggle(show);
        $saleCostFields.find(':input').prop('disabled', !show);
        $saleCostFields.find('.selectpicker').selectpicker('refresh');
    }

    function showSaleUnknownFields(show) {
        $saleUnknownFields.toggle(show);
        if (!show) $saleUnknownFields.find(':checkbox').prop('checked', false);
        $saleUnknownFields.find(':input').prop('disabled', !show).prop('required', show);
    }

    // Commissioning recognition elements
    const $recMode = $form.find('[data-stock-recognition-mode]');
    const $recAction = $form.find('[name="recognition_action"]');
    const $recDetails = $form.find('[data-recognition-details]');
    const $recSection = $form.find('[data-recognition-section]');
    const $recognizedCostCallout = $form.find('[data-stock-recognized-cost-callout]');
    const $roundedCostCallout = $form.find('[data-stock-rounded-cost-callout]');
    const $recAmount = $form.find('[data-recognition-amount]');
    const $recAmountHelp = $form.find('[data-recognition-amount-help]');
    const $recPeriodType = $form.find('[name="rec_period_type"]');
    const $recPeriodDates = $form.find('[data-recognition-period-dates]');
    const $previewCard = $form.find('[data-commissioning-preview-card]');
    const $unknownCostCallout = $form.find('[data-stock-unknown-cost-callout]');
    const $zeroCostCallout = $form.find('[data-stock-zero-cost-callout]');
    const $unpaidCostCallout = $form.find('[data-stock-unpaid-cost-callout]');
    const $recProperty = $form.find('[name="recognition_property_id"]');
    function setCommissioningRecognitionState(state, data) {
        if (operation !== 'commissioning') return;
        const choiceAvailable = state === 'unrecognized' || state === 'rounded_zero';
        const expenseNeeded = state === 'unrecognized';
        $recSection.toggle(choiceAvailable);
        $recSection.attr('data-selected-cost-state', state || '');
        $recAction.prop('disabled', !choiceAvailable).prop('required', choiceAvailable);
        if (!choiceAvailable) $recAction.prop('checked', false);
        if (choiceAvailable && !$recAction.filter(':checked').length) $recAction.filter('[value="later"]').prop('checked', true);
        const showExpenseDetails = expenseNeeded && $recAction.filter(':checked').val() === 'now';
        $recDetails.find(':input').not('[data-recognition-amount]').prop('disabled', !showExpenseDetails);
        $recDetails.toggle(showExpenseDetails);
        $recAmount.prop('disabled', !expenseNeeded || !!$moveGroup.val());
        $recMode.val(choiceAvailable && $recAction.filter(':checked').val() === 'now'
            ? (expenseNeeded ? ($recPeriodType.filter(':checked').val() || 'immediate') : 'immediate') : 'none');
        if ($recProperty.hasClass('selectpicker') && typeof $recProperty.selectpicker === 'function') $recProperty.selectpicker('refresh');
        $recognizedCostCallout.hide().empty();
        $roundedCostCallout.toggle(state === 'rounded_zero');
        $zeroCostCallout.toggle(state === 'zero');
        $unknownCostCallout.toggle(state === 'unknown');
        if (state === 'recognized' && data) {
            $recognizedCostCallout.text('Стоимость уже учтена: ' + data.already_recognized_formatted + ' ₽. Новое списание не требуется.');
            const prior = data.prior_recognition;
            if (prior && prior.type === 'expense') {
                $recognizedCostCallout.append(' Расход #' + prior.expense_id + ' от ' + (prior.date || '—') + ', период ' + (prior.period_from || '—') + ' – ' + (prior.period_to || '—') + ', объект: ' + (prior.property_name || '—') + '.');
                $recognizedCostCallout.append($('<a/>', {href: prior.expense_url, text: ' Открыть расход'}));
            } else if (prior && prior.type === 'previously_recognized') {
                $recognizedCostCallout.append(' При добавлении указано «Стоимость уже была учтена ранее»; дата и расход прежнего признания не подтверждены.');
            } else {
                $recognizedCostCallout.append(' Источник и дата прежнего признания для выбранных единиц не подтверждены.');
            }
            $recognizedCostCallout.show();
        }
    }
    const $expenseGroup = $form.find('[name="expense_group"]');
    // In-use cost recognition elements
    const movementsEndpoint = $form.data('movementsUrl');
    const $sourceMovement = $form.find('[data-source-movement]');
    const $sourceMovementGroup = $form.find('[data-source-movement-group]');
    const $recPreviewCard = $form.find('[data-recognition-preview-card]');
    let recognitionPreviewRequest = 0;
    const prefillMovementId = Number($form.data('prefillMovementId')) || null;

    const prefillItemId = Number($form.data('prefillItemId')) || null;
    const prefillStatus = $form.data('prefillStatus') || null;
    const prefillUnitIds = (($form.data('prefillUnitIds') || '') + '').split(',').filter(Boolean).map(Number);
    let availableUnits = [];
    function hasMixedUnitGroups() {
        if ($balance.find(':selected').data('tracking-mode') !== 'individual') return false;
        const selected = new Set(($units.val() || []).map(String));
        return new Set(availableUnits.filter(unit => selected.has(String(unit.id))).map(unit => unit.recognition_group || 'unproven')).size > 1;
    }
    let shouldApplyPrefill = Boolean(prefillItemId && prefillStatus);
    let balancesRequest = 0;

    function clearAvailability(message) {
        commissioningPreviewRequest++;
        recognitionPreviewRequest++;
        availableUnits = [];
        if (exitPreviewEndpoint) {
            exitPreviewRequest++;
            $exitSelection.val('').prop('disabled', true);
            $exitSubmit.prop('disabled', true);
            $exitGroupFields.hide();
            $exitGroup.prop('disabled', true).val('');
            showExitEffects(false, false);
        }
        $saleSelection.val('').prop('disabled', true);
        $saleSubmit.prop('disabled', true);
        if ($saleExpensePreview.length) {
            salePreviewRequest++;
            $saleExpensePreview.text('Выберите имущество и количество для расчёта управленческого расхода при продаже.');
        }
        $balance.empty().append($('<option/>', { value: '', text: message }));
        if ($balance.hasClass('selectpicker')) {
            $balance.selectpicker('refresh');
        }
        $quantity.removeAttr('max');
        $availability.text('');
        $units.empty();
        $unitsGroup.hide();
        $detailedUnits.empty();
        $form.trigger('stock:balances-cleared');
        $saleLotFields.hide();
        $moveGroupField.hide();
        $moveGroup.prop('disabled', true).prop('required', false).val('');
        $recognitionLotField.hide();
        $recognitionLot.prop('disabled', true).val('');
        $form.find('[data-recognition-balance-id]').val('');
        if ($recognitionLot.length) {
            $recAmount.prop('readOnly', true);
            $form.find('[data-recognition-legacy-amount]').prop('disabled', true);
        }
        if ($recognitionLot.length) $recognitionSubmit.prop('disabled', true);
        showSaleCostFields(false);
        showSaleUnknownFields(false);
        $saleLot.empty().append($('<option/>', {value: '', text: 'Выберите партию'}));
        $saleLot.prop('disabled', true);
        $saleGroup.empty();
        $saleGroup.prop('disabled', true);
        $saleGroupSummary.text('Выберите группу, чтобы распределить продажу по партиям в порядке их создания.');
        saleLots = [];
        $fifoPreview.hide();
        $previewCard.hide();
        if ($sourceMovement.length) {
            $sourceMovement.empty().append($('<option/>', { value: '', text: 'Сначала выберите остаток' }));
            $sourceMovementGroup.hide();
        }
        if ($recPreviewCard.length) {
            $recPreviewCard.hide();
        }
    }

    function loadBalances() {
        const request = ++balancesRequest;
        const sourceId = $source.val();
        if (!sourceId) {
            clearAvailability('Сначала выберите объект-источник');
            return;
        }

        clearAvailability('Загрузка доступных остатков...');
        $.getJSON(endpoint, { operation: operation, source_property_id: sourceId })
            .done(function (response) {
                if (request !== balancesRequest) return;
                availableUnits = response.units || [];
                saleLots = response.sale_lots || [];
                $balance.empty().append($('<option/>', { value: '', text: 'Выберите доступный остаток' }));
                $.each(response.balances, function (_, balance) {
                    $balance.append($('<option/>', {
                        value: balance.item_id + ':' + balance.status,
                        text: balance.label,
                        'data-item-id': balance.item_id,
                        'data-status': balance.status,
                        'data-quantity': balance.quantity,
                        'data-usable-quantity': balance.usable_quantity,
                        'data-blocked-quantity': balance.blocked_quantity,
                        'data-unit-name': balance.unit_name,
                        'data-kind': balance.kind,
                        'data-tracking-mode': balance.tracking_mode,
                        'data-unknown-cost': balance.unknown_cost ? 'true' : 'false',
                        'data-cost-state': balance.cost_state || 'specified',
                        'data-is-unpaid': balance.is_unpaid ? 'true' : 'false',
                        'data-unrecognized-cost': balance.unrecognized_cost_kopecks || 0,
                        'data-original-cost': balance.original_cost_kopecks || 0,
                        'data-source-url': balance.source_url || '',
                    }));
                });
                if ($balance.hasClass('selectpicker')) {
                    $balance.selectpicker('refresh');
                }
                if (operation === 'write-off' && ($form.find('[name="balance_id"]').length || $form.find('[data-fixed-unit-details]').length)) {
                    const fixed = $form.find('[name="stock_item_id"]').val() + ':' + $form.find('[name="source_status"]').val();
                    if ($balance.find('option[value="' + fixed + '"]').length) $balance.val(fixed).trigger('change');
                }
                if (!response.balances.length) {
                    $availability.text('На выбранном объекте нет доступных остатков для этого действия.');
                } else if (shouldApplyPrefill) {
                    const value = prefillItemId + ':' + prefillStatus;
                    if ($balance.find('option[value="' + value + '"]').length) {
                        $balance.val(value).trigger('change');
                        if ($balance.hasClass('selectpicker')) {
                            $balance.selectpicker('refresh');
                        }
                        if (prefillUnitIds.length) {
                            $units.val(prefillUnitIds.map(String)).trigger('change');
                        }
                    }
                    shouldApplyPrefill = false;
                }
                $form.trigger('stock:balances-loaded', [availableUnits]);
            })
            .fail(function (xhr) {
                if (request !== balancesRequest) return;
                clearAvailability('Не удалось получить доступные остатки.');
                $availability.text(xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : 'Проверьте выбранный объект.');
            });
    }

    $source.on('change', loadBalances);
    $balance.on('change', function () {
        const $selected = $(this).find(':selected');
        const physicalQuantity = $selected.data('quantity');
        const quantity = physicalQuantity;
        if (!quantity) {
            if (exitPreviewEndpoint) {
                exitPreviewRequest++;
                $exitSelection.val('').prop('disabled', true);
                $exitSubmit.prop('disabled', true);
                $exitPreview.text('Выберите ТМЦ и количество для расчёта стоимости.');
                showExitEffects(false, false);
            }
            if ($saleExpensePreview.length) {
                salePreviewRequest++;
                $saleExpensePreview.text('Выберите имущество и количество для расчёта управленческого расхода при продаже.');
                $saleSubmit.prop('disabled', true);
            }
            $quantity.removeAttr('max');
            $availability.is('input') ? $availability.val('') : $availability.text('');
            $form.find('[data-stock-unknown-cost-warning]').hide();
            $saleLotFields.hide();
            showSaleCostFields(false);
            showSaleUnknownFields(false);
            $saleLot.prop('disabled', true).val('');
            $saleGroup.prop('disabled', true).val('');
            $unknownCostCallout.hide();
            $zeroCostCallout.hide();
            $unpaidCostCallout.hide();
            $previewCard.hide();
            if (operation === 'commissioning') setCommissioningRecognitionState(null);
            return;
        }
        $form.find('[name="stock_item_id"]').val($selected.data('item-id'));
        $form.find('[name="source_status"]').val($selected.data('status'));
        // Recognition-action changes can request a preview before the new balance's groups load.
        $moveGroup.val('');
        if ($newStatus.length) {
            const transitions = $form.data('statusTransitions') || {};
            $newStatus.find('option').each(function () {
                $(this).prop('disabled', !(transitions[$selected.data('status')] || []).includes($(this).val()));
            });
            $newStatus.val($newStatus.find('option:not(:disabled)').first().val());
        }

        if (operation === 'commissioning') {
            $unpaidCostCallout.toggle($selected.data('is-unpaid') === 'true' || $selected.data('is-unpaid') === true);
            setCommissioningRecognitionState(null);
        }

        if (operation === 'write-off') {
            $form.find('[data-stock-unknown-cost-warning]').hide();
            const itemKind = $selected.data('kind');
            const $group = $form.find('[name="expense_group"]');
            if ($group.length && !$group.data('user-modified')) {
                $group.val(itemKind === 'consumable' ? 'opex' : 'capex');
            }
        }
        const matchingUnits = availableUnits.filter(function (unit) {
            return unit.item_id === $selected.data('item-id') && unit.status === $selected.data('status')
                && (operation !== 'recognition' || Number(unit.unrecognized_cost_kopecks) > 0);
        });
        const matchingLots = saleLots.filter(function (lot) {
            return lot.item_id === Number($selected.data('item-id')) && lot.status === $selected.data('status') && lot.supported;
        });
        if (exitPreviewEndpoint) {
            const quantityTracked = $selected.data('tracking-mode') === 'quantity';
            const fixedLotId = Number($form.find('input[name="stock_lot_id"]').val());
            const totals = {};
            matchingLots.filter(function (lot) { return !fixedLotId || lot.lot_id === fixedLotId; }).forEach(function (lot) {
                Object.keys(lot.groups).forEach(function (name) { totals[name] = (totals[name] || 0) + lot.groups[name].quantity; });
            });
            const names = Object.keys(totals);
            $exitGroup.empty().append($('<option/>', {value: '', text: 'Выберите группу'}));
            names.forEach(function (name) { $exitGroup.append($('<option/>', {value: name, text: groupNames[name] + ': ' + totals[name] + ' шт.'})); });
            $exitGroup.val(names.includes(prefillRecognitionGroup) ? prefillRecognitionGroup : (names.length === 1 ? names[0] : ''));
            $exitGroup.prop('disabled', !quantityTracked || !names.length).prop('required', quantityTracked && names.length > 1);
            $exitGroupFields.toggle(quantityTracked && names.length > 1);
            $form.find('[data-exit-group-summary]').text(names.map(function (name) { return groupNames[name] + ': ' + totals[name] + ' шт.'; }).join('; '));
            $exitPreview.text(!quantityTracked || names.length ? 'Выберите ТМЦ и количество для расчёта стоимости.' : 'Нет подтверждённой истории групп; перед списанием нужна сверка.');
            $exitGroup.trigger('change');
        }
        if ($moveGroup.length) {
            const totals = {};
            matchingLots.forEach(function (lot) {
                Object.keys(lot.groups).forEach(function (name) {
                    totals[name] = (totals[name] || 0) + lot.groups[name].quantity;
                });
            });
            const names = Object.keys(totals);
            $moveGroup.empty().append($('<option/>', {value: '', text: 'Выберите группу'}));
            names.forEach(function (name) {
                $moveGroup.append($('<option/>', {value: name, text: groupNames[name] + ': ' + totals[name] + ' шт.'}));
            });
            $moveGroup.val(names.includes(prefillRecognitionGroup) ? prefillRecognitionGroup : (names.length === 1 ? names[0] : ''));
            $moveGroup.prop('disabled', $selected.data('tracking-mode') !== 'quantity' || !names.length);
            $moveGroup.prop('required', $selected.data('tracking-mode') === 'quantity' && names.length > 1);
            if (operation === 'commissioning' && names.length) {
                $recAmount.val('').prop('readOnly', true).prop('disabled', true);
                $recAmountHelp.text('Будет признана полная рассчитанная стоимость выбранных целых единиц.');
            }
            $moveGroupField.toggle($selected.data('tracking-mode') === 'quantity' && names.length > 1);
            $form.find('[data-move-group-summary]').text('Доступно: ' + names.map(function (name) { return groupNames[name] + ' — ' + totals[name] + ' шт.'; }).join('; '));
            $moveGroup.trigger('change');
        }
        if ($recognitionLot.length) {
            const eligible = matchingLots.filter(function (lot) { return (lot.groups.unrecognized || {}).quantity > 0; });
            $sourceMovementGroup.hide();
            $sourceMovement.val('');
            $recognitionLot.empty().append($('<option/>', {value: '', text: 'Выберите партию'}));
            eligible.forEach(function (lot) {
                const group = lot.groups.unrecognized;
                $recognitionLot.append($('<option/>', {value: lot.balance_id, text: 'Партия #' + lot.lot_id + ': ' + group.quantity + ' шт., ' + (group.cost_kopecks / 100).toFixed(2) + ' ₽', 'data-quantity': group.quantity, 'data-cost': group.cost_kopecks}));
            });
            $recognitionLotField.toggle($selected.data('tracking-mode') === 'quantity' && eligible.length > 0);
            $recognitionLot.prop('disabled', $selected.data('tracking-mode') !== 'quantity' || !eligible.length);
            const wanted = Number($form.data('prefillBalanceId'));
            $recognitionLot.val(eligible.some(function (lot) { return lot.balance_id === wanted; }) ? String(wanted) : (eligible.length === 1 ? String(eligible[0].balance_id) : ''));
            $recognitionLot.trigger('change');
        }
        if ($saleLotFields.length) {
            const isQuantitySale = $selected.data('tracking-mode') === 'quantity';
            $saleLotFields.toggle(isQuantitySale);
            showSaleCostFields(false);
            showSaleUnknownFields(false);
            $saleLot.empty().append($('<option/>', {value: '', text: 'Автоматически из нескольких партий'}));
            $saleGroup.empty().append($('<option/>', {value: '', text: 'Выберите группу'}));
            $saleLot.prop('disabled', !isQuantitySale);
            $saleGroup.prop('disabled', !isQuantitySale);
            if (isQuantitySale) {
                saleLots.filter(function (lot) {
                    return lot.item_id === Number($selected.data('item-id')) && lot.status === $selected.data('status');
                }).forEach(function (lot) {
                    $saleLot.append($('<option/>', {
                        value: lot.balance_id,
                        text: 'Партия #' + lot.lot_id + ': ' + lot.quantity + ' шт.' + (lot.supported ? '' : ' (требуется сверка истории)'),
                        disabled: !lot.supported,
                    }));
                });
                if (prefillBalanceId && $saleLot.find('option[value="' + prefillBalanceId + '"]:not(:disabled)').length) {
                    $saleLot.val(String(prefillBalanceId));
                } else if ($saleLot.find('option:not(:disabled)').length === 2) {
                    $saleLot.val($saleLot.find('option:not(:disabled)').last().val());
                }
            }
        }
        $units.empty();
        if (operation === 'recognition') $units.append($('<option/>', { value: '', text: 'Выберите экземпляр' }));
        $.each(matchingUnits, function (_, unit) {
            $units.append($('<option/>', { value: unit.id, text: unit.label }));
        });
        if (matchingUnits.length && (operation !== 'write-off' || !$form.find('input[name="unit_ids[]"]').length)) {
            $unitsGroup.show();
            if (operation !== 'transfer' && !$form.find('[data-fixed-unit-details]').length) {
                $quantity.attr('type', 'hidden').prop('required', false);
            }
            if (operation === 'recognition') {
                $sourceMovementGroup.hide();
                $quantity.closest('.form-group').hide();
                $quantity.val(1);
                if (prefillUnitIds.length) {
                    $units.val(prefillUnitIds[0]);
                }
                $form.find('[name="stock_unit_id"]').val($units.val());
                const unitBalance = responseUnitBalanceId($units.val(), availableUnits);
                $form.find('[data-recognition-balance-id]').val(unitBalance || '');
                $recognitionSubmit.prop('disabled', !unitBalance);
                const selectedUnit = availableUnits.find(function (entry) { return entry.id === Number($units.val()); });
                if (selectedUnit) $recAmount.val((selectedUnit.unrecognized_cost_kopecks / 100).toFixed(2).replace('.', ','));
                loadRecognitionPreview();
            } else {
                $quantity.closest('.form-group').hide();
                $quantity.val(0);
                $availability.is('input') ? $availability.val($selected.data('status')) : $availability.text('Выберите конкретные экземпляры.');
            }
        } else {
            $unitsGroup.hide();
            $detailedUnits.empty();
            if (operation !== 'transfer' && !$form.find('[data-fixed-unit-details]').length) {
                $quantity.attr('type', 'number').prop('required', true);
            }
            if (!$form.find('input[name="unit_ids[]"]').length) $quantity.closest('.form-group').show();
            if (!$form.find('input[name="unit_ids[]"]').length) $quantity.attr('max', quantity).val(Math.min(Number($quantity.val()) || 1, quantity));
            const blockedQuantity = $selected.data('blocked-quantity') || 0;
            const text = 'Доступно: ' + quantity + ' ' + $selected.data('unit-name') + '.';
            $availability.is('input') ? $availability.val($selected.data('status')) : $availability.text(blockedQuantity && !['write-off', 'commissioning', 'recognition'].includes(operation) ? text + ' Заблокировано до оценки: ' + blockedQuantity + '.' : text);

        }

        if ($saleLotFields.is(':visible')) {
            $saleLot.trigger('change');
        }
        loadCommissioningPreview();
        loadSaleExpensePreview();
        loadExitPreview();
    });

    $sourceMovement.on('change', function () {
        const $sel = $(this).find(':selected');
        const avail = Number($sel.data('available')) || 1;
        $quantity.attr('max', avail);
        if (Number($quantity.val()) > avail) {
            $quantity.val(avail);
        }
        loadRecognitionPreview();
    });

    $units.on('change', function () {
        if (operation === 'recognition') {
            $form.find('[name="stock_unit_id"]').val($(this).val());
            $form.find('[data-recognition-balance-id]').val(responseUnitBalanceId($(this).val(), availableUnits) || '');
            const unit = availableUnits.find(function (entry) { return entry.id === Number($units.val()); });
            $recAmount.val(unit ? (unit.unrecognized_cost_kopecks / 100).toFixed(2).replace('.', ',') : '');
            $recognitionSubmit.prop('disabled', !$form.find('[data-recognition-balance-id]').val());
            loadRecognitionPreview();
        } else {
            $quantity.val($(this).val() ? $(this).val().length : 0);
            loadCommissioningPreview();
            loadSaleExpensePreview();
            loadExitPreview();
        }
    });

    function responseUnitBalanceId(unitId, units) {
        const unit = units.find(function (entry) { return entry.id === Number(unitId); });
        return unit && unit.balance_id;
    }

    $recognitionLot.on('change', function () {
        $form.find('[data-recognition-balance-id]').val($(this).val() || '');
        const $selected = $(this).find(':selected');
        const available = Number($selected.data('quantity')) || 0;
        if (available) {
            $quantity.attr('max', available);
            if (Number($quantity.val()) > available) $quantity.val(available);
            const cost = Number($selected.data('cost')) || 0;
            const take = Number($quantity.val()) || 1;
            const share = Math.floor(cost / available) * take + Math.max(0, take - (available - cost % available));
            $recAmount.val((share / 100).toFixed(2).replace('.', ','));
            $recAmountHelp.text('Рассчитано по выбранной партии: ' + (share / 100).toFixed(2) + ' ₽. Сумма не редактируется.');
        }
        $recognitionSubmit.prop('disabled', !available);
        loadRecognitionPreview();
    });

    $moveGroup.on('change', function () {
        if ($moveGroup.val()) {
            const available = saleLots.filter(function (lot) {
                return lot.item_id === Number($form.find('[name="stock_item_id"]').val()) && lot.status === $form.find('[name="source_status"]').val();
            }).reduce(function (sum, lot) { return sum + ((lot.groups[$moveGroup.val()] || {}).quantity || 0); }, 0);
            $quantity.attr('max', available);
            if (Number($quantity.val()) > available) $quantity.val(available);
        }
        if (operation === 'commissioning') setCommissioningRecognitionState($moveGroup.val() === 'unrecognized' ? 'unrecognized' : null);
        loadCommissioningPreview();
    });

    const groupNames = {recognized: 'Уже учтена', unrecognized: 'Ещё не учтена', zero: 'Подтверждённый ноль', unknown: 'Неизвестна'};
    $exitGroup.on('change', function () {
        const fixedLotId = Number($form.find('input[name="stock_lot_id"]').val());
        const available = saleLots.filter(function (lot) {
            return lot.item_id === Number($form.find('[name="stock_item_id"]').val()) && lot.status === $form.find('[name="source_status"]').val() && (!fixedLotId || lot.lot_id === fixedLotId);
        }).reduce(function (total, lot) { return total + ((lot.groups[$exitGroup.val()] || {}).quantity || 0); }, 0);
        if (available) {
            $quantity.attr('max', available);
            if (Number($quantity.val()) > available) $quantity.val(available);
        }
        loadExitPreview();
    });
    if (exitPreviewEndpoint) $quantity.on('input change', loadExitPreview);
    if (exitPreviewEndpoint) $form.find('[name="consumption_date"], [name="write_off_date"]').on('change', loadExitPreview);
    function eligibleSaleLots(lot) {
        return lot ? [lot] : saleLots.filter(function (entry) {
            return entry.supported && entry.item_id === Number($form.find('[name="stock_item_id"]').val()) && entry.status === $form.find('[name="source_status"]').val();
        });
    }
    $saleLot.on('change', function () {
        const lot = saleLots.find(function (entry) { return entry.balance_id === Number($saleLot.val()); });
        $saleGroup.empty().append($('<option/>', {value: '', text: 'Выберите группу'}));
        const eligible = eligibleSaleLots(lot);
        const totals = {};
        eligible.forEach(function (entry) {
            Object.keys(entry.groups).forEach(function (name) {
                totals[name] = (totals[name] || 0) + entry.groups[name].quantity;
            });
        });
        const groups = Object.keys(totals);
        $saleGroupSummary.text(groups.length ? 'Доступно по группам: ' + groups.map(function (name) {
            return groupNames[name] + ' — ' + totals[name] + ' шт.';
        }).join('; ') : 'Нет подтверждённых партий для продажи.');
        groups.forEach(function (name) {
            $saleGroup.append($('<option/>', {value: name, text: groupNames[name] + ': ' + totals[name] + ' шт.'}));
        });
        if (prefillRecognitionGroup && groups.includes(prefillRecognitionGroup)) {
            $saleGroup.val(prefillRecognitionGroup);
        } else if (groups.length === 1) {
            $saleGroup.val(groups[0]);
        }
        $saleGroupField.toggle(groups.length > 1);
        // Even a hidden sole choice must be submitted by the browser.
        $saleGroup.prop('disabled', groups.length === 0);
        $saleGroup.trigger('change');
    });
    $saleGroup.on('change', function () {
        const lot = saleLots.find(function (entry) { return entry.balance_id === Number($saleLot.val()); });
        const eligible = eligibleSaleLots(lot);
        const available = eligible.reduce(function (count, entry) { return count + ((entry.groups[$saleGroup.val()] || {}).quantity || 0); }, 0);
        showSaleCostFields(false);
        showSaleUnknownFields(false);
        $saleGroupAvailability.text(available ? 'В выбранной группе доступно ' + available + ' шт.' : 'Выберите группу учёта стоимости.');
        if (available) {
            $quantity.attr('max', available);
            if (Number($quantity.val()) > available) $quantity.val(available);
        }
        loadSaleExpensePreview();
        loadExitPreview();
    });

    function loadSaleExpensePreview() {
        if (!saleExpensePreviewEndpoint) return;
        const request = ++salePreviewRequest;
        $saleSelection.val('').prop('disabled', true);
        showSaleCostFields(false);
        showSaleUnknownFields(false);
        const quantitySale = $saleLotFields.is(':visible');
        $saleSubmit.prop('disabled', true);
        const itemId = $form.find('[name="stock_item_id"]').val();
        const unitIds = $unitsGroup.is(':visible') ? ($units.val() || []) : [];
        const quantity = $unitsGroup.is(':visible') ? unitIds.length : Number($quantity.val());
        if (hasMixedUnitGroups()) {
            $saleExpensePreview.text('Выбранные экземпляры относятся к разным группам учёта стоимости. Проведите каждую группу отдельно.');
            return;
        }
        if (!$source.val() || !itemId || !quantity || ($unitsGroup.is(':visible') && !unitIds.length) || ($saleLotFields.is(':visible') && !$saleGroup.val())) {
            $saleExpensePreview.text('Выберите имущество и количество для расчёта управленческого расхода при продаже.');
            return;
        }
        $saleExpensePreview.text('Рассчитываем стоимость списания…');
        $.getJSON(saleExpensePreviewEndpoint, {
            source_property_id: $source.val(),
            stock_item_id: itemId,
            source_status: $form.find('[name="source_status"]').val(),
            quantity: quantity,
            unit_ids: unitIds,
            stock_balance_id: $saleLotFields.is(':visible') ? $saleLot.val() : undefined,
            recognition_group: $saleLotFields.is(':visible') ? $saleGroup.val() : undefined,
        }).done(function (response) {
            if (request !== salePreviewRequest) return;
            const data = response.data;
            showSaleCostFields(!data.unknown_cost && data.expense_kopecks > 0);
            showSaleUnknownFields(data.unknown_cost);
            $saleSelection.val(data.selection).prop('disabled', false);
            $saleSubmit.prop('disabled', false);
            const lots = (data.lots || []).map(function (entry) {
                return (entry.unit_id ? 'Экземпляр #' + entry.unit_id + ' (партия #' + entry.lot_id + ')' : 'Партия #' + entry.lot_id) + ': ' + entry.quantity + ' шт., ' + (entry.cost_share_kopecks === null ? 'стоимость неизвестна' : (entry.cost_share_kopecks / 100).toLocaleString('ru-RU', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' ₽');
            }).join('; ');
            if (data.unknown_cost) {
                $saleExpensePreview.text('Стоимость выбранного имущества неизвестна. ' + lots + '. Управленческий расход не создаётся.');
            } else {
                const amount = (data.expense_kopecks / 100).toLocaleString('ru-RU', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                const cost = (data.cost_share_kopecks / 100).toLocaleString('ru-RU', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                $saleExpensePreview.text(lots + '. Стоимость выбранных единиц: ' + cost + ' ₽. Управленческий расход на ещё не учтённую стоимость: ' + amount + ' ₽. Доход от продажи и поступление денег будут отражены отдельно.');
            }
        }).fail(function (xhr) {
            if (request !== salePreviewRequest) return;
            $saleSubmit.prop('disabled', true);
            $saleExpensePreview.text((xhr.responseJSON && xhr.responseJSON.message) || 'Не удалось рассчитать расход. Проверьте выбранное имущество.');
        });
    }

    if (saleExpensePreviewEndpoint) {
        $quantity.on('input change', loadSaleExpensePreview);
    }

    $form.on('change', 'input[name="recognition_action"]', function () {
        if (operation === 'commissioning' && $recSection.is(':hidden')) return;
        const action = $form.find('[name="recognition_action"]:checked').val();
        if (operation === 'commissioning') {
            const expenseNeeded = $recSection.attr('data-selected-cost-state') === 'unrecognized' && action === 'now';
            $recDetails.find(':input').not('[data-recognition-amount]').prop('disabled', !expenseNeeded);
            if ($recProperty.hasClass('selectpicker') && typeof $recProperty.selectpicker === 'function') $recProperty.selectpicker('refresh');
        }
        if (action === 'now') {
            $recDetails.toggle($recSection.attr('data-selected-cost-state') !== 'rounded_zero');
            if (operation === 'commissioning' && $moveGroup.length) {
                $recAmount.val('').prop('readOnly', true).prop('disabled', true);
                $recAmountHelp.text('Будет признана полная рассчитанная стоимость выбранных целых единиц.');
            }
            const periodType = operation === 'commissioning' && $recSection.attr('data-selected-cost-state') === 'rounded_zero'
                ? 'immediate' : ($form.find('[name="rec_period_type"]:checked').val() || 'immediate');
            $recMode.val(periodType);
        } else {
            $recDetails.hide().css('display', 'none');
            $recMode.val('none');
        }
        loadCommissioningPreview();
    });

    $form.on('click', 'label[for="recActionNow"], label[for="recActionLater"]', function () {
        const forId = $(this).attr('for');
        setTimeout(function () {
            $('#' + forId).trigger('change');
        }, 10);
    });

    $recPeriodType.on('change', function () {
        const periodType = $(this).val();
        if ($form.find('[name="recognition_action"]:checked').val() === 'now') {
            $recMode.val(periodType);
        }
        if (periodType === 'period') {
            $recPeriodDates.show();
        } else {
            $recPeriodDates.hide();
        }
        loadCommissioningPreview();
    });

    $recAmount.on('input change', function () {
        $(this).data('user-modified', true);
        $form.find('[data-recognition-legacy-amount]').val($(this).val());
        loadCommissioningPreview();
    });

    $targetProperty.on('change', loadCommissioningPreview);
    $recProperty.on('change', loadCommissioningPreview);

    function loadFifoPreview() {
        if (!fifoEndpoint || $unitsGroup.is(':visible') || !$quantity.val() || !$form.find('[name="stock_item_id"]').val()) {
            $fifoPreview.hide();
            return;
        }
        if ($moveGroup.length && $moveGroup.val()) {
            $fifoPreviewText.text('Из выбранной группы: ' + $moveGroup.find(':selected').text() + '. Стоимость переместится вместе с количеством.');
            $fifoPreview.show();
            return;
        }
        $.getJSON(fifoEndpoint, {
            source_property_id: $source.val(),
            stock_item_id: $form.find('[name="stock_item_id"]').val(),
            source_status: $form.find('[name="source_status"]').val(),
            quantity: $quantity.val(),
            operation: operation,
        }).done(function (response) {
            const data = response.data || {};
            const lots = data.lots || [];
            if (!lots.length) {
                $fifoPreview.hide();
                return;
            }
            let text = lots.map(function (lot) {
                return 'Партия #' + lot.lot_id + ': ' + lot.quantity + ' шт.';
            }).join('; ');
            if (data.blocked_quantity) {
                text += '. Заблокировано до оценки: ' + data.blocked_quantity + ' шт.';
            }
            $fifoPreviewText.text(text);
            $fifoPreview.show();
        }).fail(function () {
            $fifoPreview.hide();
        });
    }

    function loadCommissioningPreview() {
        if (operation !== 'commissioning' || !previewEndpoint) {
            return;
        }
        const request = ++commissioningPreviewRequest;
        const sourceId = $source.val();
        const targetId = $targetProperty.val();
        const itemId = $form.find('[name="stock_item_id"]').val();
        const qty = $quantity.val();
        const unitIds = $units.val() || [];
        if (hasMixedUnitGroups()) {
            $previewCard.hide();
            return;
        }
        if (!sourceId || !targetId || !itemId || !qty || Number(qty) < 1) {
            $previewCard.hide();
            return;
        }

        const action = $form.find('[name="recognition_action"]:checked').val() || 'later';
        const mode = $recMode.val() || 'none';
        const recAmount = $moveGroup.length && $moveGroup.val() ? '' : $recAmount.val();
        const recPropId = $recProperty.val();
        const group = $expenseGroup.val();
        if ($moveGroup.prop('required') && !$moveGroup.val()) {
            $previewCard.hide();
            return;
        }

        $.getJSON(previewEndpoint, {
            source_property_id: sourceId,
            target_property_id: targetId,
            stock_item_id: itemId,
            quantity: qty,
            unit_ids: unitIds,
            recognition_action: action,
            recognition_mode: mode,
            recognition_amount: recAmount,
            recognition_group: $moveGroup.val() || undefined,
            recognition_property_id: recPropId,
            expense_group: group,
        }).done(function (res) {
            if (request !== commissioningPreviewRequest) return;
            const d = res.data;
            if (!d) {
                $previewCard.hide();
                return;
            }
            $previewCard.show();
            const state = d.cost_state === 'unknown' || d.valuation_status !== 'confirmed' ? 'unknown'
                : d.cost_state === 'zero' ? 'zero'
                    : d.selected_recognition_group === 'recognized' || (d.already_recognized_kopecks > 0 && d.max_recognition_kopecks === 0) ? 'recognized'
                        : d.max_recognition_kopecks === 0 ? 'rounded_zero' : 'unrecognized';
            setCommissioningRecognitionState(state, d);
            $form.find('[data-preview-badge]').text(state === 'recognized' ? 'Уже учтена' : (state === 'unrecognized' || state === 'rounded_zero') ? (action === 'now' ? 'Учесть сейчас' : 'Учесть позже') : 'Без нового расхода');
            $form.find('[data-preview-source-title]').text(d.source_property.name);
            $form.find('[data-preview-source-before]').text(d.source_property.before_quantity + ' ' + d.unit_name + ' (уже учтено: ' + d.source_property.before_recognized_formatted + ' ₽, ещё не учтено: ' + d.source_property.before_unrecognized_formatted + ' ₽)');
            $form.find('[data-preview-source-after]').text(d.source_property.after_quantity + ' ' + d.unit_name + ' (уже учтено: ' + d.source_property.after_recognized_formatted + ' ₽, ещё не учтено: ' + d.source_property.after_unrecognized_formatted + ' ₽)');

            $form.find('[data-preview-target-title]').text(d.target_property.name);
            $form.find('[data-preview-target-before]').text(d.target_property.before_quantity + ' ' + d.unit_name + ' (признано: ' + d.target_property.before_recognized_formatted + ' ₽, нераспознано: ' + d.target_property.before_unrecognized_formatted + ' ₽)');
            $form.find('[data-preview-target-after]').text(d.target_property.after_quantity + ' ' + d.unit_name + ' (признано: ' + d.target_property.after_recognized_formatted + ' ₽, нераспознано: ' + d.target_property.after_unrecognized_formatted + ' ₽)');

            if (d.chosen_recognition_kopecks > 0) {
                $form.find('[data-preview-management-impact]').html('<strong>Управленческий расход:</strong> ' + d.chosen_recognition_formatted + ' ₽ (' + d.management.expense_group_label + ') на объекте ' + d.management.property_name);
            } else {
                $form.find('[data-preview-management-impact]').text(state === 'recognized' ? 'Уже учтённая стоимость переносится: ' + d.already_recognized_formatted + ' ₽. Нового управленческого расхода нет.' : state === 'rounded_zero' ? (action === 'now' ? 'Нулевая доля будет учтена; расход на 0,00 ₽ не создаётся.' : 'Учёт нулевой доли отложен; расход не создаётся.') : state === 'unrecognized' ? 'Расход отложен, нераспознано ' + d.deferred_formatted + ' ₽' : 'Новый управленческий расход не создаётся.');
            }

            if (d.source_url) {
                $form.find('[data-preview-source-link]').html('<a href="' + d.source_url + '" target="_blank"><i class="fa fa-external-link"></i> Источник партии</a>');
            } else {
                $form.find('[data-preview-source-link]').empty();
            }

            if (!$recAmount.data('user-modified') && !$moveGroup.val()) {
                const defVal = (d.suggested_share_kopecks / 100).toFixed(2).replace('.', ',');
                $recAmount.attr('placeholder', defVal);
                if (action === 'now' && !$recAmount.val()) {
                    $recAmount.val(defVal);
                }
            }
            $recAmountHelp.text($moveGroup.val()
                ? 'Полная рассчитанная стоимость: ' + d.suggested_share_formatted + ' ₽. Сумма не редактируется.'
                : 'Предлагаемая сумма: ' + d.suggested_share_formatted + ' ₽ (максимум доступно: ' + d.max_recognition_formatted + ' ₽).');
        }).fail(function () {
            if (request !== commissioningPreviewRequest) return;
            $previewCard.hide();
        });
    }

    function loadRecognitionPreview() {
        if (operation !== 'recognition' || !previewEndpoint) {
            return;
        }
        const request = ++recognitionPreviewRequest;
        if ($form.find('[data-recognition-balance-id]').val()) {
            $recPreviewCard.hide();
            return;
        }
        const propId = $source.val();
        const itemId = $form.find('[name="stock_item_id"]').val();
        const qty = $quantity.val() || 1;
        const movementId = $sourceMovement.val();
        const unitId = $form.find('[name="stock_unit_id"]').val() || $units.val();
        const amount = $recAmount.val();
        const recPropId = $recProperty.val();
        const group = $expenseGroup.val();

        if (!propId || !itemId) {
            $recPreviewCard.hide();
            return;
        }

        $.getJSON(previewEndpoint, {
            property_id: propId,
            stock_item_id: itemId,
            source_stock_transaction_id: movementId,
            stock_unit_id: unitId,
            quantity: qty,
            recognition_amount: amount,
            recognition_property_id: recPropId,
            expense_group: group,
        }).done(function (res) {
            if (request !== recognitionPreviewRequest) return;
            const d = res.data;
            if (!d) {
                $recPreviewCard.hide();
                return;
            }
            $recPreviewCard.show();
            const $errorDiv = $recPreviewCard.find('[data-preview-error]');
            const $contentDiv = $recPreviewCard.find('[data-preview-content]');
            const $submitBtn = $form.find('[data-submit-btn]');

            if (!d.is_valid) {
                let errHtml = '<i class="fa fa-exclamation-triangle mr-1"></i> ' + d.error;
                if (d.source_url) {
                    errHtml += ' <a href="' + d.source_url + '" target="_blank" class="alert-link ml-1"><i class="fa fa-external-link"></i> Проверить источник</a>';
                }
                $errorDiv.html(errHtml).show();
                $contentDiv.hide();
                $submitBtn.prop('disabled', true);
                return;
            }

            $errorDiv.hide();
            $contentDiv.show();
            $submitBtn.prop('disabled', false);

            $recPreviewCard.find('[data-preview-line-cost]').text(d.line_known_cost_formatted + ' ₽ / ' + d.line_total_quantity + ' ' + d.unit_name);
            $recPreviewCard.find('[data-preview-prior-cost]').text(d.prior_recognitions_formatted + ' ₽');
            $recPreviewCard.find('[data-preview-remaining-line]').text(d.remaining_line_unrecognized_formatted + ' ₽');
            $recPreviewCard.find('[data-preview-chosen-amount]').text(d.chosen_amount_formatted + ' ₽');

            $recPreviewCard.find('[data-preview-inuse-title]').text(d.in_use_property.name + ' (в эксплуатации)');
            $recPreviewCard.find('[data-preview-inuse-before]').text(d.in_use_property.before_unrecognized_formatted + ' ₽');
            $recPreviewCard.find('[data-preview-inuse-after]').text(d.in_use_property.after_unrecognized_formatted + ' ₽');

            if (d.stored_property) {
                $recPreviewCard.find('[data-preview-stored-title]').text(d.stored_property.name + ' (на хранении)');
                $recPreviewCard.find('[data-preview-stored-before]').text(d.stored_property.before_unrecognized_formatted + ' ₽');
                let afterText = d.stored_property.after_unrecognized_formatted + ' ₽';
                if (d.extra_kopecks > 0) {
                    afterText += ' (списано ' + d.extra_formatted + ' ₽ вариации)';
                }
                $recPreviewCard.find('[data-preview-stored-after]').text(afterText);
            } else {
                $recPreviewCard.find('[data-preview-stored-title]').text('Склад');
                $recPreviewCard.find('[data-preview-stored-before]').text('0,00 ₽');
                $recPreviewCard.find('[data-preview-stored-after]').text('0,00 ₽');
            }

            if (d.source_url) {
                $recPreviewCard.find('[data-preview-source-link]').html('<a href="' + d.source_url + '" target="_blank" class="text-muted"><i class="fa fa-external-link"></i> Источник партии</a>');
            } else {
                $recPreviewCard.find('[data-preview-source-link]').empty();
            }

            if (!$recAmount.data('user-modified')) {
                const defVal = (d.suggested_share_kopecks / 100).toFixed(2).replace('.', ',');
                $recAmount.attr('placeholder', defVal);
                if (!$recAmount.val()) {
                    $recAmount.val(defVal);
                    $form.find('[data-recognition-legacy-amount]').val(defVal);
                }
            }
            $recAmountHelp.text('Подсказка: ' + d.suggested_share_formatted + ' ₽ за ' + d.quantity + ' ' + d.unit_name + ' (исходная пропорциональная доля), не фиксируется до сохранения.');
        }).fail(function () {
            if (request !== recognitionPreviewRequest) return;
            $recPreviewCard.hide();
        });
    }

    $quantity.on('input change', function () {
        if ($recognitionLot.length && $recognitionLot.val()) {
            $recognitionLot.trigger('change');
        }
        loadFifoPreview();
        loadCommissioningPreview();
        loadRecognitionPreview();
    });
    $balance.on('change', function () {
        loadFifoPreview();
        loadRecognitionPreview();
    });
    $form.find('[name="expense_group"]').on('change', function () {
        $(this).data('user-modified', true);
        loadCommissioningPreview();
        loadRecognitionPreview();
    });
    $recProperty.on('change', function () {
        loadCommissioningPreview();
        loadRecognitionPreview();
    });
    $recAmount.on('input change', function () {
        $(this).data('user-modified', true);
        loadCommissioningPreview();
        loadRecognitionPreview();
    });

    // Recognition period handling (e.g. on consumption form)
    if (window.initRecognitionPeriodControls) {
        window.initRecognitionPeriodControls($form);
    }

    const $consumptionDate = $form.find('[name="consumption_date"]');
    const $dirtyFlag = $form.find('[name="recognition_period_dirty"]');
    const $recPeriodControl = $form.find('.js-recognition-period-control');

    if ($consumptionDate.length && $recPeriodControl.length) {
        $consumptionDate.on('input change', function () {
            const isDirty = String($dirtyFlag.val()) === '1';
            const newDate = $(this).val();
            if (!isDirty && newDate && window.updateRecognitionPeriodRange) {
                window.updateRecognitionPeriodRange($recPeriodControl, newDate, newDate);
            }
        });

        const $rangeInput = $recPeriodControl.find('.js-recognition-period-range-input');
        $rangeInput.on('apply.daterangepicker', function () {
            $dirtyFlag.val('1');
        });
        $recPeriodControl.find('.js-recognition-period-from, .js-recognition-period-to').on('change', function () {
            $dirtyFlag.val('1');
        });
    }

    if ($source.val()) {
        loadBalances();
    }
});
